<template>
  <div class="flex items-center gap-1.5 overflow-x-auto">
    <button
      v-for="score in scores"
      :key="score"
      type="button"
      class="flex h-8 w-8 items-center justify-center border border-amber-300 bg-white text-xs font-semibold text-amber-900 hover:bg-amber-100 focus:outline-none focus:ring-2 focus:ring-amber-700 disabled:cursor-not-allowed disabled:opacity-60 dark:border-amber-800 dark:bg-amber-950/50 dark:text-amber-100 dark:hover:bg-amber-900"
      :disabled="disabled"
      @click="$emit('pick', score)"
    >
      {{ score }}
    </button>
  </div>
</template>

<script setup>
defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['pick'])

const scores = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
</script>
